import { call, fork, put, take } from 'typed-redux-saga'
import { AppSocketType, SocketMessageTypes, WorkerMessageData } from 'Modules'
import { END, EventChannel, eventChannel } from 'redux-saga'
import { Callback } from 'Src/types/utilTypes'
import { Action } from 'Types/action'
import {
	chatChannelHandlerFactory,
	ChatSocketDataPayload,
	chatSocketSlice,
	MessageCode,
} from 'Pages/chat'
import { parseInDepth } from 'Helpers'
import { createChatWsConnection } from './createChatWsConnection'
import { reconnectChatPingWatcher } from './reconnectChatPingWatcher'

function* watcherChannel(channel: EventChannel<unknown>) {
	while (true) {
		const channelAction = yield* take(channel)
		yield* put(channelAction as Action<unknown>)
	}
}

export function* createChatWorker() {
	yield* put(chatSocketSlice.actions.setHasWorker(true))

	const channel = eventChannel((dispatch: Callback) => {
		const runHandler = chatChannelHandlerFactory(dispatch)

		const handler = (e: MessageEvent<WorkerMessageData<string>>) => {
			if (e.data.appSocketType === AppSocketType.UNI_CHAT) {
				const data = parseInDepth(e?.data?.data?.payload) as ChatSocketDataPayload

				if (data?.type === SocketMessageTypes.PING) {
					dispatch(chatSocketSlice.actions.setCurrentPing(data.message as number))
				}

				if (data?.type === SocketMessageTypes.WELCOME) {
					dispatch(chatSocketSlice.actions.subscribeChannels([]))
				}

				if ((data as unknown as MessageCode) === MessageCode.CLOSE) {
					navigator.serviceWorker.removeEventListener('message', handler)
					return
				}
				runHandler(data)
			}
		}

		navigator.serviceWorker.addEventListener('message', handler)

		return () => dispatch(END)
	})

	yield* call(createChatWsConnection)
	yield* fork(reconnectChatPingWatcher)
	yield* call(watcherChannel, channel)
}
